import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MdDragHandle } from "@react-icons/all-files/md/MdDragHandle";
import type { FC } from "react";
import styled from "styled-components";

interface Props {
  id: string;
  label: string;
  isDragging?: boolean;
}

const WeekTodoSortableItem: FC<Props> = ({ id, label }) => {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style: React.CSSProperties = {
    transition: transition || undefined,
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.3 : 1,
  };

  return (
    <Row ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Handle aria-hidden>
        <MdDragHandle />
      </Handle>
      <Label>{label}</Label>
    </Row>
  );
};

export default WeekTodoSortableItem;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid ${({ theme }) => theme.app.border};
  background: ${({ theme }) => theme.app.bg.white};
  cursor: grab;
  user-select: none;

  &:first-child {
    border-top: none;
  }

  &:active {
    cursor: grabbing;
  }
`;

const Handle = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.app.text.light1};
  font-size: 18px;
`;

const Label = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.app.text.dark2};
`;
